import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";
import { ProfileContext } from "context/ProfileContext";
import NFTMarketplace from "views/admin/marketplace";
import { getStoredUser, isPendingVendorSession } from "utils/session";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");
  const profileData = useContext(ProfileContext);
  const pendingVendor = isPendingVendorSession(getStoredUser());
  const pendingRoutePaths = React.useMemo(
    () => new Set(["pending-approval", "profile", "settings"]),
    []
  );
  const adminRoutes = React.useMemo(
    () => routes.filter((route) => route.layout === "/admin" && route.path !== ":id"),
    []
  );

  const isDashboardRoute = React.useCallback(() => {
    const isSingleAdminSegment = /^\/admin\/[^/]+$/.test(location.pathname);
    const isStaticAdminRoute = adminRoutes.some(
      (route) => location.pathname === `${route.layout}/${route.path}`
    );

    return isSingleAdminSegment && !isStaticAdminRoute;
  }, [adminRoutes, location.pathname]);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(adminRoutes);
  }, [adminRoutes, isDashboardRoute, location.pathname]);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";

    if (isDashboardRoute()) {
      setCurrentRoute("Dashboard");
      return "Dashboard";
    }

    for (let i = 0; i < routes.length; i++) {
      if (location.pathname === `${routes[i].layout}/${routes[i].path}`) {
        setCurrentRoute(routes[i].name);
        return routes[i].name;
      }
    }

    setCurrentRoute(activeRoute);
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;

    if (isDashboardRoute()) {
      return true;
    }

    for (let i = 0; i < routes.length; i++) {
      if (location.pathname === `${routes[i].layout}/${routes[i].path}`) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin" && (!pendingVendor || pendingRoutePaths.has(prop.path))) {
        return <Route path={`/${prop.path}`} element={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}>
          {/* Routes */}
          <div className="mt-5 h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={""}
              brandText={currentRoute}
              secondary={getActiveNavbar(adminRoutes)}
              {...rest}
            />
            <div className="mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(adminRoutes)}
                {!pendingVendor ? <Route path="/:id" element={<NFTMarketplace />} /> : null}

                <Route
                  path="/"
                  element={
                    <Navigate
                      to={
                        pendingVendor ? "/admin/pending-approval" : `/admin/${profileData.user_id}`
                      }
                      replace
                    />
                  }
                />
                <Route
                  path="*"
                  element={
                    <Navigate
                      to={
                        pendingVendor ? "/admin/pending-approval" : `/admin/${profileData.user_id}`
                      }
                      replace
                    />
                  }
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
